import * as React from 'react';

export interface PhoneFrameProps {
    daySrc: string;
    nightSrc: string;
    alt: string;
}

export const PhoneFrame: React.FunctionComponent<PhoneFrameProps> = ({daySrc, nightSrc, alt}: PhoneFrameProps) => (
    <div className="hiw-phone">
        <div className="hiw-device">
            <div className="hiw-screen">
                <img className="hiw-shot hiw-shot--day" src={daySrc} alt={alt} decoding="async"/>
                <img className="hiw-shot hiw-shot--night" src={nightSrc} alt="" aria-hidden decoding="async"/>
            </div>
        </div>
    </div>
);
